import { render, staticRenderFns } from "./OnboardingWechatSubMerchantApply.vue?vue&type=template&id=6f6fe3e8"
import script from "./OnboardingWechatSubMerchantApply.vue?vue&type=script&lang=js"
export * from "./OnboardingWechatSubMerchantApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports